import { User } from 'apis/types';

export const displayName = (user: Pick<User, 'name' | 'surname' | 'username' | 'businessName'>): string => {
    return user.name || user.surname
        ? `${user.name || ''}${user.name && user.surname ? ' ' : ''}${user.surname || ''}`
        : user.username || '';
};
